import React from 'react';
import LazyMetrics from '../LazyMetrics';
import EngagementByMonth from './EngagementByMonth';
import SharedProject from './SharedProject';
import SharedEvent from './SharedEvent';
import InvitedToOffer from './InvitedToOffer';
import InvitedToOfferAndResponded from './InvitedToOfferAndResponded';
import CreatedInviteToOffer from './CreatedInviteToOffer';
import EducatorGrowthByMonth from './EducatorGrowthByMonth';
import CompositeEducatorGrowth from './CompositeEducatorGrowth';
import EducatorStatusYear from './EducatorStatusYear';

export default function Educators(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="Educators"
        columns={1}
      >
        {/*<EducatorGrowthByMonth {...params} />*/}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <EducatorStatusYear
            subtitle="For signups up to and including this school year"
            {...params}
            schoolStart={undefined}
          />
          <EducatorStatusYear
            subtitle="For new signups this school year"
            {...params}
          />
        </div>
        <EducatorGrowthByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositeEducatorGrowth {...params} showTotals={false} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Educator Engagement"
        columns={1}
      >
        <EngagementByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <SharedProject {...params} />
          <SharedEvent {...params} />
          <InvitedToOffer {...params} />
          <InvitedToOfferAndResponded {...params} />
          <CreatedInviteToOffer {...params} />
        </div>
      </LazyMetrics>
    </>
  );
}
